import { allBeamColors } from '@vst/beam/src/react/common';
import { IconComponentType, IllustrativeIcon, Surface, Txt } from '@vst/beam';

import styles from './waitlistCard.module.scss';

type WaitlistCardProps = {
  icon: IconComponentType;
  title: string;
  subtitle: string;
  colorIcon?: allBeamColors;
};

const WaitlistCard = ({ icon, title, subtitle, colorIcon }: WaitlistCardProps) => {
  return (
    <Surface py={{ sm: '16px', md: '32px' }} px={{ sm: '16px' }} className={styles['root']}>
      <IllustrativeIcon icon={icon} size="96px" color={colorIcon} data-testid="waitlistCard" />
      <Txt pb={'16px'} pt={'32px'} variant={'heading3'} color={'regular'} style={{ fontWeight: 700 }}>
        {title}
      </Txt>
      <Txt variant={'subHeading4'} color={'info'}>
        {subtitle}
      </Txt>
    </Surface>
  );
};

export default WaitlistCard;
